import React, { useEffect } from "react";
import { isMobile, isMobileOnly } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { base_url, postHeader } from "../../../../../Helpers/request";
import { useState } from "react";
import { toast } from "react-toastify";
import Banner from '../assets/images/dubai-banner.png'
// import '../../dubai/assets/css/dubai.css'
import Slider from "react-slick";


const BannerSlider = () => {
  const history = useHistory();
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //-----------------------------------Banner
    setLoading(true);
    axios
      .get(base_url + `/home/slider`, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setLoading(false);
          setBanner(response.data.data);
          localStorage.setItem(
            "bw-bannerdata",
            JSON.stringify(response.data.data)
          );
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const settingBanner = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };


  return (
    <>
      {/* {!loading ? (
        banner?.map((val, index) => (
          <div
            className="rcs_hero_slider du_main_banner_section"
            style={{
              backgroundImage: `url(${
                isMobileOnly ? val?.mobile_image : val?.image
                isMobileOnly ? Banner : Banner
                
              })`,
            }}
          >
            <div className="rcs_hero_img">
              <Container className="dubai-showcase-container">
                <Row className="m-auto w-100">
                  <Col md={6} xs={12} className="d-flex justify-content-center" > */}
      {/* {val.btn_text === "" ? (
                      ""
                    ) : (
                      <div
                        className={`${
                          isMobile ? "text-center" : val.text_direction_class
                        } text-center`}
                      >
                        <h1 data-aos="fade-up-left" data-aos-duration="700">
                          {val.title + " " + "Dubai" }
                        </h1>
                        <p
                          data-aos="fade-up-left"
                          data-aos-duration="1200"
                          data-aos-delay="300"
                        >
                          {val.short_text}
                        </p>
                        <button
                          data-aos="fade-up-left"
                          data-aos-duration="1800"
                          data-aos-delay="400"
                          onClick={() => {
                            history.push("/" + val.btn_link);
                          }}
                          className="btn_white"
                        >
                          {val.btn_text}
                        </button>
                      </div>
                    )} */}
      <Slider {...settingBanner} className="dubai_banner_slider">
        <div>
          <div className="dubai_banner_slider_bg_img" style={{
            backgroundImage: `url(${isMobileOnly ? Banner : Banner

              })`,
          }} >
            <Container className="dubai-showcase-container">
              <Row className="d-flex align-items-center">
                <Col >
                  <div className="slide-box">
                    <h2 className="title48 font-normal dark">Custom Jewelry <br /> Design</h2>
                    <p className="title18">The Joy Of Wearing The Best</p>
                    <a href="https://dubai.demobw.com/build-your-own-ring" className="banner_slider_btn white title18">Shop Custom Jewelry </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div>
          <div className="dubai_banner_slider_bg_img" style={{
            backgroundImage: `url(${isMobileOnly ? Banner : Banner

              })`,
          }} >
            <Container className="dubai-showcase-container">
              <Row className="d-flex align-items-center">
                <Col >
                  <div className="slide-box">
                    <h2 className="title48 font-normal dark">Custom Jewelry <br /> Design</h2>
                    <p className="title18">The Joy Of Wearing The Best</p>
                    <a href="https://dubai.demobw.com/build-your-own-ring" className="banner_slider_btn white title18">Shop Custom Jewelry </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

      </Slider>

      {/* </Col>
                </Row>
              </Container>
            </div>
          </div>
        ))
      ) : (
        <div className="sk" style={{ margin: "0px" }}>
          <Skeleton variant="text" animation="wave" height={"90vh"} />
        </div>
      )} */}
    </>
  );
};

export default BannerSlider;
